import * as React from "react";
import { forwardRef } from "react";
const LogoVkSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "M12.983 19C5.466 19 1.178 13.745 1 5h3.765c.124 6.418 2.9 9.137 5.098 9.698V5h3.546v5.536c2.17-.239 4.451-2.761 5.221-5.536h3.545c-.59 3.42-3.064 5.942-4.823 6.979 1.759.84 4.576 3.041 5.648 7.021h-3.903c-.838-2.663-2.926-4.723-5.689-5.003V19z" }));
const ForwardRef = forwardRef(LogoVkSVG);
export default ForwardRef;
//# sourceMappingURL=LogoVk.js.map